package com.trevorwiebe.timesheet.admin.locations.presentation

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp

// No interactive map on web — the address is geocoded to coordinates directly.
@Composable
actual fun LocationCoordinateControls(
    form: LocationFormState,
    isGeocoding: Boolean,
    geocodeError: String?,
    onEvent: (LocationsEvent) -> Unit
) {
    Column(modifier = Modifier.fillMaxWidth()) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically
        ) {
            if (form.latitude != null && form.longitude != null) {
                Box(modifier = Modifier.weight(1f)) {
                    CoordinatePill(
                        latitude = form.latitude!!,
                        longitude = form.longitude!!,
                        onClear = { onEvent(LocationsEvent.OnClearCoordinates) }
                    )
                }
            } else {
                Text(
                    text = "No pin set",
                    fontSize = 14.sp,
                    color = MaterialTheme.colorScheme.secondary,
                    modifier = Modifier.weight(1f)
                )
            }
            if (isGeocoding) {
                CircularProgressIndicator(
                    modifier = Modifier.size(20.dp),
                    strokeWidth = 2.dp,
                    color = MaterialTheme.colorScheme.tertiary
                )
                Spacer(modifier = Modifier.width(8.dp))
            }
            TextButton(
                onClick = { onEvent(LocationsEvent.OnGeocodeAddress) },
                enabled = !isGeocoding,
                colors = ButtonDefaults.textButtonColors(
                    contentColor = MaterialTheme.colorScheme.tertiary
                )
            ) {
                Text("Get coordinates")
            }
        }
        geocodeError?.let { error ->
            Text(
                text = error,
                color = MaterialTheme.colorScheme.error,
                style = MaterialTheme.typography.bodySmall,
                modifier = Modifier.fillMaxWidth()
            )
        }
    }
}

@Composable
actual fun LocationMapPickerHost(
    visible: Boolean,
    latitude: Double?,
    longitude: Double?,
    onConfirm: (latitude: Double, longitude: Double) -> Unit,
    onDismiss: () -> Unit
) {
    // No map picker on web.
}
